<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Application Management </template>
        </page-header>
        <pro-table
            :resource="resource"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            :actions="actions"
            @action="actionHandler"
            table-class="text-xs"
            sort="created_at"
            direction="DESC"
            delete-label="title"
            :permissions="true"
        ></pro-table>
        <SmsModal :to="sendTo" v-if="showSMSModal" model="ApplicationSubmission" :id="rowID" @close="showSMSModal = false" @sent="showSMSModal = false" :meta="SMSMeta" />
    </div>
</template>

<script>
    import DataTableSetup from '../../mixins/DataTableSetup';
    import SmsModal from '@/components/modals/SmsModal'
    export default {
        name: "Submissions",
        mixins: [ DataTableSetup ],
        components: {
            SmsModal
        },
        data: function() {
            return {
                resource: 'submissions',
                numberOfFilters: 8,
                pageActions: {},
                fields: [
                    {
                        name: 'ID',
                        column: 'friendly_id_display',
                        sortCol: 'friendly_id',
                        highlight: 'highlight'
                    },
                    {
                        name: 'Name',
                        column: 'member.full_name',
                        route: '/submissions/{id}/view',
                        linked: true,
                        sortCol: 'member',
                    },
                    {
                        name: 'Form',
                        column: 'application_form.name'
                    },
                    {
                        name: 'Supplier',
                        column: 'supplier.name'
                    },
                    {
                        name: 'Amount',
                        column: 'amount',
                        currency: true,
                        sortCol: 'amount'
                    },
                    {
                        name: 'Created',
                        column: 'created_at',
                        sortCol: 'created_at',
                        date: true,
                        columnClass: 'whitespace-no-wrap',
                        format: 'DD/MM/YYYY'
                    },
                    {
                        name: 'Created By',
                        column: 'created_via',
                        sortCol: 'created_via',
                    },
                    {
                        name: 'Xero',
                        column: 'xero',
                        boolean: true,
                        align: 'center'
                    },
                    {
                        name: 'Application',
                        column: 'application_status.name',
                        highlight: 'application_status.colour'
                    },
                    {
                        name: 'FAS Status',
                        column: 'fas_status.name',
                        highlight: 'fas_status.colour'
                    },
                    {
                        name: 'Supplier',
                        column: 'supplier_status.name',
                        highlight: 'supplier_status.colour'
                    }
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'SMS', method: 'sendSMS', icon: 'paper-plane',  type: 'method', tooltip: 'Send SMS', permissions: 'submissions.edit' },
                        { label: 'View', link: 'view', icon: 'eye',  type: 'router-link', tooltip: 'View', permissions: 'submissions.show' },
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'submissions.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'submissions.destroy' },
                    ]
                },
                showSMSModal: false,
                sendTo: {},
                rowID: null,
                SMSMeta: null
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
            sendSMS(payload){
                this.sendTo = {
                    name: payload.item.member.full_name,
                    number: payload.item.member.mobile ? payload.item.member.mobile : payload.item.member.parent ? payload.item.member.parent.mobile : null
                }
                this.rowID = payload.item.id

                this.SMSMeta = {
                    first: payload.item.member.first,
                    last: payload.item.member.last,
                    status: payload.item.application_status.name,
                    supplier: payload.item.supplier?.name,
                    amount: '$'+payload.item.amount.toFixed(2),
                    submissionID: payload.item.friendly_id_display
                }

                this.showSMSModal = true;
            }
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'ID/Supplier...'
            };
            this.filters.push(searchFilter);

            //Member Filter
            const memberFilter = {
                label: 'Member',
                name: 'member',
                type: 'text',
                width: 'w-1/4',
                value: this.memberValue,
                placeholder: 'Name...'
            };

            this.filters.push(memberFilter);

            // Application Forms
            const applicationFormsFilter = {
                label: 'Application Form',
                name: 'application_form',
                type: 'select',
                options: this.$store.getters.forms.map(function (form) {
                    return {label: form.name, value: form.id};
                }),
                width: 'w-1/4',
                value: this.applicationFormValue,
                placeholder: 'Form...'
            };

            if (this.$store.getters.forms.length === 0){
                this.$store.dispatch('GET_APPLICATION_FORMS').then(() => {
                    applicationFormsFilter.options = this.$store.getters.forms.map(function (form) {
                        return { label: form.name, value: form.id };
                    });
                    applicationFormsFilter.value = this.applicationFormValue;
                    this.filters.push(applicationFormsFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(applicationFormsFilter);
            }

            // Application Statuses
            const applicationStatusFilter = {
                label: 'Application Status',
                name: 'application_status',
                type: 'select',
                options: this.$store.getters.applicationStatuses.map(function (status) {
                    return {label: status.name, value: status.id};
                }),
                width: 'w-1/4',
                value: this.applicationStatusValue,
                placeholder: 'Application Status...'
            };
            if (this.$store.getters.applicationStatuses.length === 0){
                this.$store.dispatch('GET_APPLICATION_STATUSES').then(() => {
                    applicationStatusFilter.options = this.$store.getters.applicationStatuses.map(function (status) {
                        return { label: status.name, value: status.id };
                    });
                    applicationStatusFilter.value = this.applicationStatusValue;
                    this.filters.push(applicationStatusFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(applicationStatusFilter);
            }

            // TAP Statuses
            const fasStatusFilter = {
                label: 'FAS Status',
                name: 'fas_status',
                type: 'select',
                options: this.$store.getters.fasApplicationStatuses.map(function (status) {
                    return {label: status.name, value: status.id};
                }),
                width: 'w-1/4',
                value: this.fasStatusValue,
                placeholder: 'FAS Status...'
            };

            if (this.$store.getters.fasApplicationStatuses.length === 0){
                this.$store.dispatch('GET_FAS_APPLICATION_STATUSES').then(() => {
                    fasStatusFilter.options = this.$store.getters.fasApplicationStatuses.map(function (status) {
                        return { label: status.name, value: status.id };
                    });
                    fasStatusFilter.value = this.fasStatusValue;
                    this.filters.push(fasStatusFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(fasStatusFilter);
            }

            // Supplier Statuses
            const supplierStatusFilter = {
                label: 'Supplier Status',
                name: 'supplier_status',
                type: 'select',
                options: this.$store.getters.supplierStatuses.map(function (status) {
                    return {label: status.name, value: status.id};
                }),
                width: 'w-1/4',
                value: this.supplierStatusValue,
                placeholder: 'Supplier Status...'
            };

            if (this.$store.getters.supplierStatuses.length === 0){
                this.$store.dispatch('GET_SUPPLIER_STATUSES').then(() => {
                    supplierStatusFilter.options = this.$store.getters.supplierStatuses.map(function (status) {
                        return { label: status.name, value: status.id };
                    });
                    supplierStatusFilter.value = this.supplierStatusValue;
                    this.filters.push(supplierStatusFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(supplierStatusFilter);
            }

            //Search Filter
            const dobFilter = {
                label: 'Date of Birth',
                name: 'dob',
                type: 'text-mask',
                mask: '##/##/####',
                width: 'w-1/4',
                value: this.dobValue,
                placeholder: 'DD/MM/YYYY'
            };

            this.filters.push(dobFilter);

            const paymentDateFilter = {
                label: 'Payment Date',
                name: 'paymentDate',
                type: 'dateRange',
                width: 'w-1/4',
                value: this.paymentDateValue,
                placeholder: 'DD/MM/YYYY'
            };

            this.filters.push(paymentDateFilter);

            this.pageActions = {
                buttons: [
                    {
                        label: 'New Application',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/submissions/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('submissions.create') !== -1,
                    }
                ],
                additional: []
            }
        },
        computed: {
            applicationFormValue(){
                const filters = this.$store.getters.filters;
                if (filters.submissions.application_form){
                    return filters.submissions.application_form;
                } else {
                    return null;
                }
            },
            applicationStatusValue(){
                const filters = this.$store.getters.filters;
                if (filters.submissions.application_status){
                    return filters.submissions.application_status;
                } else {
                    return null;
                }
            },
            supplierStatusValue(){
                const filters = this.$store.getters.filters;
                if (filters.submissions.supplier_status){
                    return filters.submissions.supplier_status;
                } else {
                    return null;
                }
            },
            fasStatusValue(){
                const filters = this.$store.getters.filters;
                if (filters.submissions.fas_status){
                    return filters.submissions.fas_status;
                } else {
                    return null;
                }
            },
            searchValue () {
                const filters = this.$store.getters.filters;

                if (filters.submissions.search){
                    return filters.submissions.search.value;
                } else {
                    return '';
                }
            },
            memberValue () {
                const filters = this.$store.getters.filters;

                if (filters.submissions.member){
                    return filters.submissions.member.value;
                } else {
                    return '';
                }
            },
            dobValue () {
                const filters = this.$store.getters.filters;

                if (filters.submissions.dob){
                    return filters.submissions.dob.value;
                } else {
                    return '';
                }
            },
            paymentDateValue () {
                const filters = this.$store.getters.filters;

                if (filters.submissions.paymentDate){
                    return filters.submissions.paymentDate;
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped>

</style>
